<template>
    <div class="info">
        <img v-if="isOpen" src="../../assets/aui-icon-menu.png" alt="" style="width: 20px;height: 20px" @click="open()">
        <img v-else  src='../../assets/openclick.png' alt="" style="width: 20px;height: 20px" @click="open()">
      <div class="fr">
      <!-- <div class="fr" @click.stop="myInfo()"> -->
          <el-dropdown style="cursor: pointer;">
            <span class="el-dropdown-link">
                <span class="user">
                <i class="userHeader"></i>
                {{username}}&nbsp;&nbsp;
            </span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item >
                <a @click="outLogin()" style="display: inline-block;width: 100%">退出   </a>
              </el-dropdown-item>
              <el-dropdown-item >
                <a @click="myInfo()" style="display: inline-block;width: 100%">个人信息   </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <router-link  to="updatePsd">修改密码</router-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span style="font-size: 13px">{{hospitalName}}</span>
      </div>
      <div style="float: right; margin-right: 10px;font-size: 20px;height: 26px;cursor: pointer;" @click="ceshi">
        <i class="el-icon-service"><span style="font-size: 14px;padding-left: 5px;padding-bottom: 5px">测试&nbsp; /</span></i>
      </div>
      <el-dialog title="个人信息" :visible.sync="isFalse" width="40%">
        <el-form>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item label="登录名称:" :label-width="formLabelWidth">
                <el-input v-model="formData.loginName" size="small" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="真实姓名:" :label-width="formLabelWidth">
                <el-input v-model="formData.userName" size="small" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item label="性别:" :label-width="formLabelWidth">
                <el-radio-group v-model="formData.sex" disabled>
                  <el-radio :label="1">男</el-radio>
                  <el-radio :label="2">女</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在医院:" :label-width="formLabelWidth">
                <el-input v-model="formData.hospitalName" size="small" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
          <el-col :span="12">
            <el-form-item label="技术职称:" :label-width="formLabelWidth">
              <el-input v-model="formData.professional" size="small" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮件:" :label-width="formLabelWidth">
              <el-input v-model="formData.email" size="small" disabled=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="3">
            <el-col :span="12">
              <el-form-item label="手机号码:" :label-width="formLabelWidth">
                <el-input v-model="formData.tel" size="small" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
                <el-button @click="isFalse = false">取 消</el-button>
            </span>
      </el-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
          username: '',
          isOpen:true,
          hospitalName:'',
          isFalse:false,
          formLabelWidth: "90px",
          technicalTitles:[
            {title:'高级',value:1},
            {title:'副高',value:2},
            {title:'中级',value:3},
            {title:'初级',value:4},
            {title:'其他',value:5}
          ],
          formData:{
            loginName:'',
            userName:'',
            sex:null,
            hospitalName: '',
            professional:'',
            email: '',
            tel: ''
          }
        }
    },
    methods:{
      ceshi() {
        this.Axios.get("/api/LiveCourse/GetJoinUrl").then(res=>{
          const data = res.data
          if (data.status === 100) {
            let url = 'https://launcher.zhumu.me/j/15169598289?zpk=' + data.data
            window.open(url)
          } else if (data.status === 200) {
            this.$message({
              showClose: true,
              message: '未查询到账号信息!',
              type: 'error'
            })
          }
        })
      },
      myInfo() {
        this.isFalse=true
        this.Axios.get('/api/User/GetUserInfo/'+ window.localStorage.getItem('UserId')).then(res=>{
          if(res.status===200){
            this.formData.loginName = res.data.loginName
            this.formData.userName = res.data.userName
            this.formData.sex = res.data.sex
            this.formData.hospitalName = window.localStorage.getItem('HospitalName')
            if(res.data.professional===1){
              this.formData.professional='高级'
            }else if(res.data.professional===2){
              this.formData.professional='副高'
            }else if(res.data.professional===3){
              this.formData.professional='中级'
            }else if(res.data.professional===4){
              this.formData.professional='初级'
            }else{
              this.formData.professional='其他'
            }
            this.formData.email = res.data.email
            this.formData.tel = res.data.phoneNum
          }else{

          }
        })

      },
      outLogin(){
        this.Axios.get('/api/Cookies/UserExit').then(res=>{
          window.localStorage.clear()
          this.$router.push({path:'login'})
        })
      },
      open(){
        this.$store.dispatch('changeNavAction')
        this.isOpen=!this.isOpen
      }
    },
    created(){
        this.username=window.localStorage.getItem('LoginName')
        this.hospitalName=window.localStorage.getItem('HospitalName')
    }
}
</script>

<style scoped lang="less">
    .info{
        overflow:hidden;
        padding:1%;
        background-color:#fff;
        width: 98%;
        /*border-bottom: 1px solid #f0f3f5;*/
        i,.item{
            float:left;
        }
        .enlarge,.item{
            margin-right:20px;
        }
        .enlarge{
            width:21px;
            height:21px;
            background-image:url(../../assets/enlarge.png);
            background-repeat:no-repeat;
            background-size: cover;
        }
        .bell{
            width:18px;
            height:21px;
            background-image:url(../../assets/bell.png);
            background-repeat:no-repeat;
            background-size: cover;
        }
        .user{
            color:rgba(0,0,0,0.65);
            font-size:14px;
            .userHeader{
                width:24px;
                height:24px;
                background-image:url(../../assets/newHeader.png);
                background-repeat:no-repeat;
                background-size:cover;
                margin-right:5px;
            }
        }

      .el-dialog__wrapper {
        /deep/ .el-dialog__header {
          border-bottom: 1px solid #d9d9d9;
        }
        /deep/ .el-dialog__footer {
          border-top: 1px solid #d9d9d9;
        }
        /deep/ .el-dialog__title {
          font-size: 14px;
        }

        /deep/ .el-dialog{
          width:770px;
        }
        /deep/ .el-input--suffix{
          width: 254px;
        }
        /deep/ .el-textarea__inner{
          width: 620px;
        }
        .uploadBtn {
          margin-right: 10px;
        }
        .consent {
          padding-left: 10px;
        }
        .conditionTextarea {
          width: 70px;
          height: 60px;
          line-height: 24px !important;
          text-align: right;
          margin-right: 8px;
        }
        .el-select {
          width: 224px;
        }
        .el-textarea {
          width: 557px;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/Info.vue